module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image1_dochimom-7d8a3341c7a24c3e7f74a220a84b1822.png";